import { allergies } from '$tablet-app/src/app/recipes/data/allergies';
import { toggleInList } from '$tablet-app/src/app/utils/arrays';
import React from 'react';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';
import AllergyTile from './AllergyTile';

const AllergyPreferencesView = () => {
  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const selected_allergies = useMealPreferenceDialogState(
    (state) => state.draft_preferences.allergies
  );

  const onPress = (allergy: string) =>
    update({ allergies: toggleInList(selected_allergies, allergy) });

  return (
    <Container>
      <Row>
        {allergies.slice(0, 4).map((item) => (
          <AllergyTile
            key={item.text}
            {...item}
            onPress={onPress}
            selected={selected_allergies?.includes(item.text)}
          />
        ))}
      </Row>

      <Row>
        {allergies.slice(4, 8).map((item) => (
          <AllergyTile
            key={item.text}
            {...item}
            onPress={onPress}
            selected={selected_allergies?.includes(item.text)}
          />
        ))}
      </Row>
    </Container>
  );
};

const Container = styled.View`
  padding: 25px;
  gap: 20px;
`;

const Row = styled.View`
  flex-direction: row;
  gap: 20px;
`;

export default AllergyPreferencesView;
